var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.siteKeyActiva)?_c('div',{staticClass:"gr-captcha"},[_c('div',{ref:"widget"}),(_vm.fallo)?_c('p',{staticClass:"gr-captcha-aviso"},[_vm._v(_vm._s(_vm.textoFallo))]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }